import React, { useEffect } from 'react';
import {
    Container, Box, Typography
} from '@mui/material';
import LinksTable, { LinkItem } from './LinksTable';
import { useSeason } from '../SeasonContext';

export const LINKS_BY_SEASON: Record<string, LinkItem[]> = {
    'pw_26_27': [
        { label: 'Jets CSDHL Schedule', url: 'https://gamesheetstats.com/seasons/15220/teams/528217/schedule', displayText: 'Schedule on CSDHL' },
        { label: 'CSDHL PeeWee Major Standings', url: 'https://gamesheetstats.com/seasons/15220/teams/528217/standings', displayText: 'Standings on CSDHL' },
        { label: 'Chicago Jets 2014 Homepage', url: 'https://www.chicagojetshockey.org', displayText: 'chicagojetshockey.org' },
        { label: 'Team Calendar', url: 'https://www.chicagojetshockey.org/page/show/413245-calendar', displayText: 'Calendar on chicagojetshockey.org' },
        { label: 'Jets PeeWee Major MYR', url: 'https://myhockeyrankings.com/team-info?y=2026&t=2564', displayText: 'MyHockeyRankings' },
    ],
    'pw_25_26': [
        { label: 'Jets CSDHL Schedule', url: 'https://gamesheetstats.com/seasons/10449/teams/372150?configuration%5Bprimary-colour%5D=E52724&configuration%5Bsecondary-colour%5D=253276&filter%5Bdivision%5D=57718', displayText: 'Schedule on CSDHL' },
        { label: 'CSDHL PeeWee Minor Standings', url: 'https://gamesheetstats.com/seasons/10449/teams/372150/standings?configuration%5Bprimary-colour%5D=E52724&configuration%5Bsecondary-colour%5D=253276&filter%5Bdivision%5D=57718', displayText: 'Standings on CSDHL' },
        { label: 'Chicago Jets 2014 Homepage', url: 'https://www.chicagojetshockey.org/page/show/9092275-2014-csdhl-2025-2026-', displayText: 'chicagojetshockey.org' },
        { label: 'Team Calendar', url: 'https://www.chicagojetshockey.org/page/show/413245-calendar', displayText: 'Calendar on chicagojetshockey.org' },
        { label: 'Jets PeeWee Minor MYR', url: 'https://myhockeyrankings.com/team_info.php?y=2025&t=15140', displayText: 'MyHockeyRankings' },
    ],
};

// The main page component
const LinksPage = () => {
    const { selectedSeason } = useSeason();
    const links = LINKS_BY_SEASON[selectedSeason.key] || LINKS_BY_SEASON['pw_26_27'];

    useEffect(() => {
        document.title = `Jets '14 | ${selectedSeason.label} Links`;
    }, [selectedSeason]);

    return (
        <Container maxWidth="md">
            <Box sx={{ my: 4 }}>
                <Typography variant="h4" component="h1" gutterBottom>
                    {selectedSeason.label} Links
                </Typography>
                <LinksTable title="General" links={links} />
            </Box>
        </Container>
    );
};

export default LinksPage;

